import React from 'react';
import { Box, Typography } from '@mui/material';
import ConstantComplyLogo from '../assets/logos/ConstantComplyLogo';

interface LogoProps {
  width?: number;
  height?: number;
  color?: string;
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  width = 100, 
  height = 55, 
  color = "white",
  showText = true
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <ConstantComplyLogo 
        width={width} 
        height={height} 
        color={color} 
      />
      {showText && (
        <Typography
          variant="h5"
          component="div"
          sx={{
            color: color,
            fontWeight: 'bold',
            letterSpacing: '-0.02em',
            fontFamily: 'Arial, sans-serif',
            display: { xs: 'none', sm: 'block' } // Hide on mobile, show on larger screens
          }}
        >
          ConstantComply
        </Typography>
      )}
    </Box>
  );
};

export default Logo;
